import React from "react";
import ModalBox, { ModalBody } from "../Modal/ModalBox";
import Loader from "../Loader";
import Button from "../Button";

interface ResendVerificationModalPros {
  showModal: boolean;
  btnLoader: boolean;
  handleClick: (contactNumber: any) => void;
  closeModal: any;
  contactNumber: string;
}

const ResendVerification: React.FC<ResendVerificationModalPros> = ({
  showModal,
  btnLoader,
  handleClick,
  closeModal,
  contactNumber,
}) => {
  return (
    <ModalBox show={showModal} horizontalAlign="Center" closeModal={closeModal}>
      <ModalBody>
        <div className="p-4">
          <div className="space-y-6 md:px-8 pt-4 pb-6">
            <h3 className="font-semibold text-2xl text-center">
              Your account is not verified!
            </h3>
            <p className="md:px-12 font-normal text-base text-center">
              If the phone number has an account, an OTP will be sent on
              register phone number.
            </p>
            <p className="font-normal text-base text-center">
              OTP will send to:{" "}
              <span className="font-bold">
                +91 ******{contactNumber?.slice(6)}
              </span>
            </p>
            <div className="flex justify-center">
              <Button
                onClick={() => handleClick(contactNumber)}
                disabled={btnLoader}
              >
                {btnLoader ? <Loader size="small" /> : "Send OTP"}
              </Button>
            </div>
          </div>
        </div>
      </ModalBody>
    </ModalBox>
  );
};

export default ResendVerification;
